import React from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import { PageLoader } from "./components/page-loader";
import { Routes, Route } from 'react-router-dom';
import { createTheme, ThemeProvider, CssBaseline } from '@mui/material';
import Home from './pages/home-page';
import About from './pages/about-page';
import Asx from './pages/asx-page';
import Usa from './pages/usa-page';
import StockPage from "./pages/stock-page";
import PortfolioPage from "./pages/portfolio-page";
import SearchPage from './pages/search-page';
import { ProfilePage } from './pages/profile-page';
import  {CallbackPage}  from "./pages/callback-page";
import { AuthenticationGuard } from "./components/authentication-guard";
import Logout from './components/logout';
import FiltersPage from './pages/filter-page';
import RentinvestPage from './pages/rentinvest-page';


export const App = () => {
  const { isLoading } = useAuth0();

  const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: { default: '#121212', paper: '#1e1e1e' },
    text: { primary: '#fff' },
  },
});

  if (isLoading) {
    return (
      <div className="page-layout">
        <PageLoader />
      </div>
    );
  }
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
        <Routes>
          <Route path="" element={<Home />} />
          <Route path="/" element={<Home />} />
          <Route path="/asx" element={<Asx />} />
          <Route path="/usa" element={<Usa />} />
          <Route
            path="/search"
            element={<AuthenticationGuard component={SearchPage} />}
          />
          <Route
            path="/stock/:ticker"
            element={<AuthenticationGuard component={StockPage} />}
          />
          <Route
            path="/filter"
            element={<AuthenticationGuard component={FiltersPage} />}
          />
          <Route
            path="/portfolio"
            element={<AuthenticationGuard component={PortfolioPage} />}
          />
          <Route
            path="/profile"
            element={<AuthenticationGuard component={ProfilePage} />}
          />
          <Route path="/rentinvest" element={<RentinvestPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/callback" element={<CallbackPage />} />
        </Routes>
    </ThemeProvider>
  );
}

